import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';

interface Fields {
  view?: string | number | boolean;
  detailed_view?: string | number | boolean;
  edit?: string | number | boolean;
  admin?: string | number | boolean;
}
interface FieldsGroup {
  [key: string]: Fields;
}

type Permission = { [key: string]: Fields | FieldsGroup };

interface PermssionGroup {
  resource1: string;
  resource2?: string;
  action: string;
}

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private permissionsSource = new BehaviorSubject<Permission>({});
  permissions = this.permissionsSource.asObservable();

  constructor(private authService: AuthService) {}

  refresh() {
    this.authService.session().subscribe(
      res => {
        const { data } = res;
        const permissions = JSON.parse(data.permissions);
        this.store(permissions);
      },
      error => {
        console.error(error);
      },
    );
  }

  store(permissions: Permission) {
    this.permissionsSource.next(permissions);
  }

  allowMany(permissionGroup: Array<PermssionGroup>) {
    return permissionGroup.map((row: PermssionGroup) => {
      return this.allow(row);
    });
  }

  allow(permissionGroup: PermssionGroup) {
    const allowedValues = ['1', 1, true, 'true'];
    const { resource1, resource2, action } = permissionGroup;
    // some permissions like asset classes are nested objects
    if (this.permissionsSource.value[resource1] && this.permissionsSource.value[resource1][resource2]) {
      let permissionValue = this.permissionsSource.value[resource1][resource2][action];
      return allowedValues.includes(permissionValue);
    }
    if (this.permissionsSource.value[resource1]) {
      let permissionValue = this.permissionsSource.value[resource1][action];
      return allowedValues.includes(permissionValue);
    }
  }

  isAllowed(allow: Array<boolean>) {
    return !allow.includes(false);
  }
}
